/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import scriptLoader from 'react-async-script-loader'
import { Collapse } from 'react-collapse'
import config from 'config'

import { collapsibleClick } from '@cred/react-analytics/events'
import { withSnowplowContexts } from '@cred/react-analytics/SnowplowContextManager'

import { getCtaUrl } from 'student-loan/shared/utils'
import LendersList from 'components/lenders-list'
import { loadLendersRates } from 'common/utils/rates'

import styles from './styles.module.scss'

class ShortenedRateTableApp extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isOpen: false,
    }
  }

  render() {
    const lenders = this.loadLenders()
    const { isOpen } = this.state
    const totalLender = lenders.length
    const iconClass = isOpen ? 'icon-chevron-up' : 'icon-chevron-down'
    const { utms, theme, metaQuery } = this.props
    const ctaUrl = getCtaUrl({ utms, theme, metaQuery })

    return (
      <div className={styles.container}>
        <hr />
        <LendersList
          lenders={lenders.slice(0, 3)}
          ctaUrl={ctaUrl}
          theme={theme}
          name="StudentLoan"
        />
        <section>
          <Collapse isOpened={isOpen}>
            <LendersList
              lenders={lenders.slice(3)}
              ctaUrl={ctaUrl}
              noBorder
              theme={theme}
              name="StudentLoan"
            />
          </Collapse>
          <div className={styles.viewMoreSection} onClick={this.toggleLenderList}>
            <p className={`${styles.viewMore} secondary500`}>
              {isOpen ? 'Hide additional lenders' : `View ${totalLender - 3} more lenders`}
              <span className={`cred-icon ${iconClass}`} />
            </p>
          </div>
        </section>
      </div>
    )
  }

  /* Get rates from Rates Update library. */
  loadLenders() {
    const { isScriptLoaded, availableLenders } = this.props

    /* Get the rates after loading the ratesLibrary JS and do it only once. */
    if (isScriptLoaded) {
      return loadLendersRates({
        availableLenders,
        filters: { vertical: 'inschool' },
      })
    }

    return []
  }

  toggleLenderList = () => {
    const { trackSnowplowEvent } = this.props
    const { isOpen } = this.state

    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }))

    trackSnowplowEvent(collapsibleClick, {
      text: isOpen ? 'Hide additional lenders' : 'Show additional lenders',
      action: isOpen ? 'collapse' : 'expand',
    })
  }
}

ShortenedRateTableApp.propTypes = {
  isScriptLoaded: PropTypes.bool,
  utms: PropTypes.shape({
    utm_source: PropTypes.string,
    utm_campaign: PropTypes.string,
    utm_medium: PropTypes.string,
    utm_content: PropTypes.string,
    credclid: PropTypes.string,
    credsessid: PropTypes.string,
    renderId: PropTypes.string,
  }),
  trackSnowplowEvent: PropTypes.func,
  theme: PropTypes.string,
  metaQuery: PropTypes.string,
  availableLenders: PropTypes.instanceOf(Array),
}

ShortenedRateTableApp.defaultProps = {
  availableLenders: [],
}

export { ShortenedRateTableApp as ShortenedRateTableAppNoHoc }

export default scriptLoader(config.ratesLibraryUrl)(withSnowplowContexts(ShortenedRateTableApp))
